import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap"

/**
 * Class description
 *
 * Created: 2018-03-22
 * @author jonas
 */
export class DungeonQuestBaseStateSprite extends TimelineSprite {

    constructor(textures:PIXI.Texture[], sourceFPS?:number) {
        super(textures, sourceFPS);
        this.initGraphics();
    }

    protected initGraphics() {}

    public moveSymbolToTop() {
        if(this.parent != null && this.parent.parent != null) {
            this.parent.parent.addChild(this.parent);
        }
    }

    public getAnimation(frames?:number[], onUpdateCallback?:() => void, onCompleteCallback?:() => void):TimelineLite {
        return super.getAnimation(frames, onUpdateCallback, onCompleteCallback);
    }


}